<script setup lang="ts">
import { NumberInputField } from '@/components/Fields'
import EditableFieldWrapper from './EditableFieldWrapper.vue'

defineProps<{
    label?: string
    tooltip?: string
    value?: number
    boldLabel?: boolean
    isInEditMode?: boolean
    required?: boolean
    showableElement?: boolean
    min?: number
    max?: number
    suffix?: string
    errorText?: string
}>()
defineEmits<{ (e: 'change', value: number | undefined): void }>()
</script>

<template>
    <EditableFieldWrapper
        :label="label"
        :tooltip="tooltip"
        :value="value"
        :suffix="suffix"
        :boldLabel="boldLabel"
        :showableElement="showableElement"
        :isInEditMode="isInEditMode">
        <NumberInputField
            :modelValue="value"
            :placeholder="label"
            @change="$emit('change', $event)"
            :suffix="suffix"
            :errorText="errorText"
            :min="min"
            :max="max"
            v-bind="$attrs" />
    </EditableFieldWrapper>
</template>
